import React from 'react'
import HeroImage from '../assets/heroImage.jpeg'
import { MdOutlineKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-scroll'

const Home = () => {
  return (
    <div
      name="home"
      className="w-full pt-16 bg-gradient-to-b from-black via-black to-gray-800 md:pt-5"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="mt-20 flex flex-col justify-center lg:h-full h-72 md:w-[80%]">
          <h2 className="text-4xl sm:text-6xl font-bold text-white leading-tight">
            Design-Minded <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Full Stack Engineer
            </span>
          </h2>

          <p className="text-gray-400 py-4 max-w-md pt-5 text-lg">
            With over a decade of experience spanning UI/UX design and
            enterprise software engineering, I bridge the gap between intuitive
            user interfaces and scalable back-end systems.
          </p>

          <div className="flex gap-4 mt-2">
            <Link
              to="work"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer font-medium hover:scale-105 duration-200"
            >
              View Work
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>

            <Link
              to="projects"
              smooth
              duration={500}
              className="text-gray-300 w-fit px-6 py-3 my-2 flex items-center rounded-md border border-gray-600 hover:border-gray-400 cursor-pointer duration-200"
            >
              Personal Projects
            </Link>
          </div>
        </div>

        <div className="mt-10 md:mt-15 md:mr-10">
          <img
            src={HeroImage}
            alt="Bicky Dhaliwal"
            className="lg:mt-10 md:rounded-2xl mx-auto md:w-full transform transition-all scale-x-[-1] duration-300 hover:scale-105 rounded-full w-[250px] h-[250px] aspect-[9/16] sm:w-[250px] sm:h-[250px] lg:h-[360px] md:h-[260px] object-cover object-top shadow-2xl border-2 border-gray-800"
          />
        </div>
      </div>
    </div>
  )
}

export default Home
